import { h5GuardInitWithKNB, loginNewWrapper } from '@cap/rzmt-core';
import '@ss/mtd-react3/lib/style/theme-yellow.css';
import './global.less';
import bootstrap, { appEnv } from '@cap/share/src/bootstrap';
import { judgeNavigatePCOrH5 } from '@cap/share/src/utils/navigation/index';
import { isBrowser } from '@cap/ssr-common-utils';
import { IAppEntryProps, RequestContext } from '@cap/ssr-common-utils/types';
import routes from './routes';
import App from './App';

import './index.css';

async function onBootstrap(ctx: RequestContext) {
  await judgeNavigatePCOrH5('pc');
  const { href } = ctx;
  bootstrap({
    lxCustom: {
      systemName: 'mddc_portal',
      platform: 'web',
    },
    href,
  });
  if (!isBrowser) return;
  window.localStorage.setItem('mtdx_pc_is_gray_user', 'true');
  h5GuardInitWithKNB();
  try {
    await Promise.race([
      loginNewWrapper.init({
        env: appEnv as any,
      }),
      (function timeout() {
        return new Promise((reslove) => {
          setTimeout(() => reslove(true), 2000);
        });
      })(),
    ]);
  } catch (err) {
    console.warn(err);
  }
}

const AppEntry: IAppEntryProps = {
  App,
  onBootstrap,
  routes,
};

export default AppEntry;
